import cn from 'clsx';
import { observer } from 'mobx-react-lite';

import { useStore } from 'hooks/useStore';
import { interpolate } from 'utils/string/format';

import css from './SMS.module.css';

interface ISMS {
  className?: string;
}

const SMS = ({ className }: ISMS) => {
  const {
    app: { i18n },
    savedFilters: { popup },
    view,
  } = useStore();

  if (!popup?.smsParams || !popup.channels.sms.value) return null;

  return (
    <span className={cn(css.sms, className)}>
      {interpolate(i18n.subscriptions.paidSms, { atis: view.atisCount(popup.smsParams.rate) })}
    </span>
  );
};

const connected = observer(SMS);

export { connected as SMS };
